import { Button } from './button'
import { Input } from './input'
import { Select } from './select'

export default {
  Button,
  Input,
  Select,
}
